import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

import Landing from "./pages/Landing";
import Signup from "./pages/Signup";
import Verify from "./pages/Verify";
import Login from "./pages/Login";
import ForgotPin from "./pages/ForgotPin";
import ResetPin from "./pages/ResetPin";
import Dashboard from "./pages/Dashboard";
import Onboarding from "./pages/Onboarding";
import Leads from "./pages/Leads";
import Dialer from "./pages/Dialer";
import WarRoom from "./pages/WarRoom";
import Goals from "./pages/Goals";
import Commissions from "./pages/Commissions";
import Analytics from "./pages/Analytics";
import AdminTeam from "./pages/AdminTeam";
import Leaderboard from "./pages/Leaderboard";
import AdminSettings from "./pages/AdminSettings";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 label-xs">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 label-xs">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-pin" element={<ForgotPin />} />
          <Route path="/reset-pin" element={<ResetPin />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
          <Route path="/leads" element={<Protected><Leads /></Protected>} />
          <Route path="/dialer" element={<Protected><Dialer /></Protected>} />
          <Route path="/war-room" element={<Protected><WarRoom /></Protected>} />
          <Route path="/goals" element={<Protected><Goals /></Protected>} />
          <Route path="/commissions" element={<Protected><Commissions /></Protected>} />
          <Route path="/analytics" element={<Protected><Analytics /></Protected>} />
          <Route path="/admin/team" element={<AdminOnly><AdminTeam /></AdminOnly>} />
          <Route path="/admin/leaderboard" element={<AdminOnly><Leaderboard /></AdminOnly>} />
          <Route path="/admin/settings" element={<AdminOnly><AdminSettings /></AdminOnly>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
